export default __webpack_public_path__ + "static/media/74.80bfd871.jpeg";